module.exports = __webpack_public_path__ + "img/logo.82994749.svg";